export const getPercentOfElapsedTime = (activeTime: number, duration: number) =>
  (activeTime / duration) * 100;
